"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_final_form_1 = require("react-final-form");
var editableCell_1 = __importDefault(require("./editableCell"));
var FormFieldColumn = function (props) {
    var row = props.row, value = props.value, index = props.index, name = props.name, isEditable = props.isEditable, Component = props.cellComponent, validate = props.validate, parse = props.parse, format = props.format, type = props.type, cellAlignment = props.cellAlignment;
    var data = {
        row: row,
        value: value,
        index: index,
    };
    var fieldName = typeof name === 'function' ? name(data) : name;
    var isEditableFunction = typeof isEditable === 'function';
    var isEditableResult = isEditableFunction ? isEditable(data) : isEditable;
    return (react_1.default.createElement(react_final_form_1.Field, { name: fieldName, component: editableCell_1.default, isEditable: isEditableResult, isEditableFunction: isEditableFunction, row: row, index: index, columnComponent: Component, columnValidate: validate, type: type, cellAlignment: cellAlignment, parse: parse, format: format }));
};
FormFieldColumn.propTypes = {
    /** Row data injected by the Table component. */
    row: prop_types_1.default.object,
    /** Cell value injected by the Table component. */
    value: prop_types_1.default.any,
    /** Row index injected by the Table component. */
    index: prop_types_1.default.number,
    /** The name of the editable input field. It can be a simple string value or a function
     * that receive the row, value and index and based on this data you can construct the name string returned.
     */
    name: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.func]).isRequired,
    /** Indicates whether the cell is editable or not. It can be a boolean value or a function that receive
     * the row, value and index and based on this data you can return a boolean.
     */
    isEditable: prop_types_1.default.oneOfType([prop_types_1.default.bool, prop_types_1.default.func]),
    /** The component class or function that is going to be use to render
     * the content of each cell on this column cell component.
     */
    cellComponent: prop_types_1.default.func,
    /** A function that takes the field value, all the values of the form and the meta data about the field and returns an error
     * if the value is invalid, or undefined if the value is valid. */
    validate: prop_types_1.default.func,
    /** A function that takes the value from the input and name of the field and converts the value into the value you want stored
     * as this field's value in the form. Common usecases include converting strings into Numbers or parsing
     * localized dates into actual javascript Date objects.
     * Almost always used in conjuction with format.
     */
    parse: prop_types_1.default.func,
    /** A function that takes the value from the form values and the name of the field and formats the value to give to the input.
     * Common use cases include converting javascript Date values into a localized date string.
     * Almost always used in conjunction with parse.
     */
    format: prop_types_1.default.func,
    /** Field input type. */
    type: prop_types_1.default.oneOf(['text', 'number']),
    /** Determines the alignment of the text in each column cell.
     * Available options are: left, right, center.
     * This value defaults to `left` when the Table uses the `default` variant and defaults to `center` when uses the `listview` variant.
     */
    cellAlignment: prop_types_1.default.oneOf(['left', 'right', 'center']),
};
FormFieldColumn.defaultProps = {
    row: undefined,
    value: undefined,
    index: undefined,
    isEditable: false,
    cellComponent: undefined,
    validate: undefined,
    parse: undefined,
    format: undefined,
    type: 'text',
    cellAlignment: undefined,
};
exports.default = FormFieldColumn;
//# sourceMappingURL=index.js.map